export const EST = {
    appFormat: 'EST',
    iso6391: 'et',
    iso6392: 'est',
    localeName: 'et-EE'
};
export const ENG = {
    appFormat: 'ENG',
    iso6391: 'en',
    iso6392: 'eng',
    localeName: 'en-US'
};
export const RUS = {
    appFormat: 'RUS',
    iso6391: 'ru',
    iso6392: 'rus',
    localeName: 'ru-RU'
};
export const LIT = {
    appFormat: 'LIT',
    iso6391: 'lt',
    iso6392: 'lit',
    localeName: 'lt-LT'
};
export const LAV = {
    appFormat: 'LAV',
    iso6391: 'lv',
    iso6392: 'lav',
    localeName: 'lv-LV'
};
export const FIN = {
    appFormat: 'FIN',
    iso6391: 'fi',
    iso6392: 'fin',
    localeName: 'fi-FI'
};
